<script setup lang="ts">
import * as Sentry from "@sentry/vue";
import { toRef, watch } from "vue";

import { useHeicObjectUrl } from "@/components/MyStudents/Submissions/composables/useHeicObjectUrl";
import SkeletonLoader from "@/components/shared/loaders/BaseSkeletonLoader.vue";

defineOptions({
  name: "documentHeicView",
});

const props = withDefaults(
  defineProps<{
    url: string;
    name?: string;
    dataTestid?: string;
  }>(),
  {
    name: "",
    dataTestid: "my-students-submission-current-document-heic",
  },
);

const emit = defineEmits<{
  (e: "error"): void;
}>();

const { objectUrl, isConverting, hasFailed } = useHeicObjectUrl(toRef(props, "url"));

watch(hasFailed, (failed: boolean): void => {
  if (!failed) {
    return;
  }
  Sentry.captureException(new Error("Failed to decode heic file on submission for My Students"), {
    tags: {
      troubleshooting_note: "Failed to decode heic file on submission for My Students",
    },
  });
  emit("error");
});
</script>

<template>
  <div v-if="url" :data-testid="dataTestid">
    <SkeletonLoader
      v-if="isConverting"
      height="h-24"
      data-testid="my-students-submission-current-document-heic-loader"
    />
    <img v-else-if="objectUrl" :src="objectUrl" :alt="name" @error="emit('error')" />
  </div>
</template>
